export default "assets/images/footer-site-logo-f221a5df.png";